import Cookies from "js-cookie";

export const setCookie = (cookiename, value) => {
  return Cookies.set(cookiename, value, {
    expires: 1,
    sameSite: "strict",
    path: "/",
  });
};

export const getCookie = (cookiename) => {
  return Cookies.get(cookiename);
};

export const removeCookie = (cookiename) => {
  return Cookies.remove(cookiename);
};
